import { SET_USER_DETAIL } from "../mutation.type";
import Vue from "vue";

const state = {
    userDetail: null,
};

const mutations = {
    [SET_USER_DETAIL]: (state, detail) => {
        Vue.set(state, "userDetail", detail)
    },
};

export default {
    state,
    mutations
}